export const dnsList = [
  {
    "tld": "kg",
    "server": "http://rdap.cctld.kg/"
  },
  {
    "tld": "mg",
    "server": "http://rdap.nic.mg/"
  },
  {
    "tld": "xn--p1acf",
    "server": "https://api.rdap.nic.xn--p1acf/"
  },
  {
    "tld": "xn--kpry57d",
    "server": "https://ccrdap.twnic.tw/taiwan/"
  },
  {
    "tld": "tw",
    "server": "https://ccrdap.twnic.tw/tw/"
  },
  {
    "tld": "na",
    "server": "https://keetmans.omadhina.co.na/"
  },
  {
    "tld": "samsung",
    "server": "https://nic.samsung/rdap/"
  },
  {
    "tld": "xn--cg4bki",
    "server": "https://nic.samsung/rdap/"
  },
  {
    "tld": "ads",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "android",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "app",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "boo",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "cal",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "channel",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "chrome",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "dad",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "day",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "dclk",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "dev",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "docs",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "drive",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "eat",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "esq",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "fly",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "foo",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "gbiz",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "gle",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "gmail",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "goog",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "google",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "guge",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "hangout",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "here",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "how",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "ing",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "map",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "meet",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "meme",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "mov",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "new",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "nexus",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "page",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "phd",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "play",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "prod",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "prof",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "rsvp",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "search",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "soy",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "xn--flw351e",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "xn--q9jyb4c",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "xn--qcka1pmc",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "youtube",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "zip",
    "server": "https://pubapi.registry.google/rdap/"
  },
  {
    "tld": "blog",
    "server": "https://rdap.blog.fury.ca/rdap/"
  },
  {
    "tld": "ca",
    "server": "https://rdap.ca.fury.ca/rdap/"
  },
  {
    "tld": "uz",
    "server": "https://rdap.cctld.uz/"
  },
  {
    "tld": "allfinanz",
    "server": "https://rdap.centralnic.com/allfinanz/"
  },
  {
    "tld": "art",
    "server": "https://rdap.centralnic.com/art/"
  },
  {
    "tld": "audio",
    "server": "https://rdap.centralnic.com/audio/"
  },
  {
    "tld": "auto",
    "server": "https://rdap.centralnic.com/auto/"
  },
  {
    "tld": "autos",
    "server": "https://rdap.centralnic.com/autos/"
  },
  {
    "tld": "baby",
    "server": "https://rdap.centralnic.com/baby/"
  },
  {
    "tld": "beauty",
    "server": "https://rdap.centralnic.com/beauty/"
  },
  {
    "tld": "best",
    "server": "https://rdap.centralnic.com/best/"
  },
  {
    "tld": "bmw",
    "server": "https://rdap.centralnic.com/bmw/"
  },
  {
    "tld": "boats",
    "server": "https://rdap.centralnic.com/boats/"
  },
  {
    "tld": "bond",
    "server": "https://rdap.centralnic.com/bond/"
  },
  {
    "tld": "box",
    "server": "https://rdap.centralnic.com/box/"
  },
  {
    "tld": "build",
    "server": "https://rdap.centralnic.com/build/"
  },
  {
    "tld": "cam",
    "server": "https://rdap.centralnic.com/cam/"
  },
  {
    "tld": "car",
    "server": "https://rdap.centralnic.com/car/"
  },
  {
    "tld": "cars",
    "server": "https://rdap.centralnic.com/cars/"
  },
  {
    "tld": "case",
    "server": "https://rdap.centralnic.com/case/"
  },
  {
    "tld": "ceo",
    "server": "https://rdap.centralnic.com/ceo/"
  },
  {
    "tld": "cfd",
    "server": "https://rdap.centralnic.com/cfd/"
  },
  {
    "tld": "christmas",
    "server": "https://rdap.centralnic.com/christmas/"
  },
  {
    "tld": "college",
    "server": "https://rdap.centralnic.com/college/"
  },
  {
    "tld": "cyou",
    "server": "https://rdap.centralnic.com/cyou/"
  },
  {
    "tld": "dealer",
    "server": "https://rdap.centralnic.com/dealer/"
  },
  {
    "tld": "deloitte",
    "server": "https://rdap.centralnic.com/deloitte/"
  },
  {
    "tld": "dhl",
    "server": "https://rdap.centralnic.com/dhl/"
  },
  {
    "tld": "diet",
    "server": "https://rdap.centralnic.com/diet/"
  },
  {
    "tld": "dvag",
    "server": "https://rdap.centralnic.com/dvag/"
  },
  {
    "tld": "fans",
    "server": "https://rdap.centralnic.com/fans/"
  },
  {
    "tld": "flowers",
    "server": "https://rdap.centralnic.com/flowers/"
  },
  {
    "tld": "fm",
    "server": "https://rdap.centralnic.com/fm/"
  },
  {
    "tld": "fo",
    "server": "https://rdap.centralnic.com/fo/"
  },
  {
    "tld": "fresenius",
    "server": "https://rdap.centralnic.com/fresenius/"
  },
  {
    "tld": "frl",
    "server": "https://rdap.centralnic.com/frl/"
  },
  {
    "tld": "fun",
    "server": "https://rdap.centralnic.com/fun/"
  },
  {
    "tld": "game",
    "server": "https://rdap.centralnic.com/game/"
  },
  {
    "tld": "gd",
    "server": "https://rdap.centralnic.com/gd/"
  },
  {
    "tld": "gent",
    "server": "https://rdap.centralnic.com/gent/"
  },
  {
    "tld": "guitars",
    "server": "https://rdap.centralnic.com/guitars/"
  },
  {
    "tld": "hair",
    "server": "https://rdap.centralnic.com/hair/"
  },
  {
    "tld": "help",
    "server": "https://rdap.centralnic.com/help/"
  },
  {
    "tld": "homes",
    "server": "https://rdap.centralnic.com/homes/"
  },
  {
    "tld": "host",
    "server": "https://rdap.centralnic.com/host/"
  },
  {
    "tld": "hosting",
    "server": "https://rdap.centralnic.com/hosting/"
  },
  {
    "tld": "icu",
    "server": "https://rdap.centralnic.com/icu/"
  },
  {
    "tld": "inc",
    "server": "https://rdap.centralnic.com/inc/"
  },
  {
    "tld": "kfh",
    "server": "https://rdap.centralnic.com/kfh/"
  },
  {
    "tld": "kpn",
    "server": "https://rdap.centralnic.com/kpn/"
  },
  {
    "tld": "kred",
    "server": "https://rdap.centralnic.com/kred/"
  },
  {
    "tld": "lat",
    "server": "https://rdap.centralnic.com/lat/"
  },
  {
    "tld": "lidl",
    "server": "https://rdap.centralnic.com/lidl/"
  },
  {
    "tld": "llp",
    "server": "https://rdap.centralnic.com/llp/"
  },
  {
    "tld": "lol",
    "server": "https://rdap.centralnic.com/lol/"
  },
  {
    "tld": "london",
    "server": "https://rdap.centralnic.com/london/"
  },
  {
    "tld": "lpl",
    "server": "https://rdap.centralnic.com/lpl/"
  },
  {
    "tld": "lplfinancial",
    "server": "https://rdap.centralnic.com/lplfinancial/"
  },
  {
    "tld": "luxury",
    "server": "https://rdap.centralnic.com/luxury/"
  },
  {
    "tld": "makeup",
    "server": "https://rdap.centralnic.com/makeup/"
  },
  {
    "tld": "mini",
    "server": "https://rdap.centralnic.com/mini/"
  },
  {
    "tld": "mom",
    "server": "https://rdap.centralnic.com/mom/"
  },
  {
    "tld": "monster",
    "server": "https://rdap.centralnic.com/monster/"
  },
  {
    "tld": "motorcycles",
    "server": "https://rdap.centralnic.com/motorcycles/"
  },
  {
    "tld": "nokia",
    "server": "https://rdap.centralnic.com/nokia/"
  },
  {
    "tld": "online",
    "server": "https://rdap.centralnic.com/online/"
  },
  {
    "tld": "ooo",
    "server": "https://rdap.centralnic.com/ooo/"
  },
  {
    "tld": "pics",
    "server": "https://rdap.centralnic.com/pics/"
  },
  {
    "tld": "pohl",
    "server": "https://rdap.centralnic.com/pohl/"
  },
  {
    "tld": "press",
    "server": "https://rdap.centralnic.com/press/"
  },
  {
    "tld": "protection",
    "server": "https://rdap.centralnic.com/protection/"
  },
  {
    "tld": "pw",
    "server": "https://rdap.centralnic.com/pw/"
  },
  {
    "tld": "qpon",
    "server": "https://rdap.centralnic.com/qpon/"
  },
  {
    "tld": "quest",
    "server": "https://rdap.centralnic.com/quest/"
  },
  {
    "tld": "reit",
    "server": "https://rdap.centralnic.com/reit/"
  },
  {
    "tld": "rent",
    "server": "https://rdap.centralnic.com/rent/"
  },
  {
    "tld": "ruhr",
    "server": "https://rdap.centralnic.com/ruhr/"
  },
  {
    "tld": "saarland",
    "server": "https://rdap.centralnic.com/saarland/"
  },
  {
    "tld": "sbs",
    "server": "https://rdap.centralnic.com/sbs/"
  },
  {
    "tld": "schwarz",
    "server": "https://rdap.centralnic.com/schwarz/"
  },
  {
    "tld": "security",
    "server": "https://rdap.centralnic.com/security/"
  },
  {
    "tld": "sfr",
    "server": "https://rdap.centralnic.com/sfr/"
  },
  {
    "tld": "site",
    "server": "https://rdap.centralnic.com/site/"
  },
  {
    "tld": "skin",
    "server": "https://rdap.centralnic.com/skin/"
  },
  {
    "tld": "smart",
    "server": "https://rdap.centralnic.com/smart/"
  },
  {
    "tld": "space",
    "server": "https://rdap.centralnic.com/space/"
  },
  {
    "tld": "stc",
    "server": "https://rdap.centralnic.com/stc/"
  },
  {
    "tld": "stcgroup",
    "server": "https://rdap.centralnic.com/stcgroup/"
  },
  {
    "tld": "storage",
    "server": "https://rdap.centralnic.com/storage/"
  },
  {
    "tld": "store",
    "server": "https://rdap.centralnic.com/store/"
  },
  {
    "tld": "tech",
    "server": "https://rdap.centralnic.com/tech/"
  },
  {
    "tld": "theatre",
    "server": "https://rdap.centralnic.com/theatre/"
  },
  {
    "tld": "tickets",
    "server": "https://rdap.centralnic.com/tickets/"
  },
  {
    "tld": "tui",
    "server": "https://rdap.centralnic.com/tui/"
  },
  {
    "tld": "uno",
    "server": "https://rdap.centralnic.com/uno/"
  },
  {
    "tld": "vg",
    "server": "https://rdap.centralnic.com/vg/"
  },
  {
    "tld": "viva",
    "server": "https://rdap.centralnic.com/viva/"
  },
  {
    "tld": "website",
    "server": "https://rdap.centralnic.com/website/"
  },
  {
    "tld": "wme",
    "server": "https://rdap.centralnic.com/wme/"
  },
  {
    "tld": "xn--4gbrim",
    "server": "https://rdap.centralnic.com/xn--4gbrim/"
  },
  {
    "tld": "xn--ngbe9e0a",
    "server": "https://rdap.centralnic.com/xn--ngbe9e0a/"
  },
  {
    "tld": "xn--vermgensberater-ctb",
    "server": "https://rdap.centralnic.com/xn--vermgensberater-ctb/"
  },
  {
    "tld": "xn--vermgensberatung-pwb",
    "server": "https://rdap.centralnic.com/xn--vermgensberatung-pwb/"
  },
  {
    "tld": "xyz",
    "server": "https://rdap.centralnic.com/xyz/"
  },
  {
    "tld": "yachts",
    "server": "https://rdap.centralnic.com/yachts/"
  },
  {
    "tld": "zuerich",
    "server": "https://rdap.centralnic.com/zuerich/"
  },
  {
    "tld": "jnj",
    "server": "https://rdap.centralnicregistry.com/jnj/"
  },
  {
    "tld": "xn--55qw42g",
    "server": "https://rdap.conac.cn/"
  },
  {
    "tld": "xn--zfr164b",
    "server": "https://rdap.conac.cn/"
  },
  {
    "tld": "crown",
    "server": "https://rdap.crown.fury.ca/rdap/"
  },
  {
    "tld": "pl",
    "server": "https://rdap.dns.pl/"
  },
  {
    "tld": "eco",
    "server": "https://rdap.eco.fury.ca/rdap/"
  },
  {
    "tld": "fi",
    "server": "https://rdap.fi/rdap/rdap/"
  },
  {
    "tld": "moscow",
    "server": "https://rdap.flexireg.net/"
  },
  {
    "tld": "xn--80adxhks",
    "server": "https://rdap.flexireg.net/"
  },
  {
    "tld": "bridgestone",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "brother",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "canon",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "datsun",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "dnp",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "epson",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "firestone",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "fujitsu",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "ggee",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "gmo",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "goldpoint",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "goo",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "hisamitsu",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "hitachi",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "honda",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "hyundai",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "infiniti",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "jcb",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "kddi",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "kia",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "komatsu",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "kyoto",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "lexus",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "lotte",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "mitsubishi",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "nagoya",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "nec",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "nhk",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "nico",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "nissan",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "okinawa",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "otsuka",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "panasonic",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "playstation",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "ricoh",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "ryukyu",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "sharp",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "shop",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "softbank",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "sony",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "suzuki",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "tokyo",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "toray",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "toshiba",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "toyota",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "yodobashi",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "yokohama",
    "server": "https://rdap.gmoregistry.net/rdap/"
  },
  {
    "tld": "bom",
    "server": "https://rdap.gtlds.nic.br/"
  },
  {
    "tld": "final",
    "server": "https://rdap.gtlds.nic.br/"
  },
  {
    "tld": "globo",
    "server": "https://rdap.gtlds.nic.br/"
  },
  {
    "tld": "rio",
    "server": "https://rdap.gtlds.nic.br/"
  },
  {
    "tld": "uol",
    "server": "https://rdap.gtlds.nic.br/"
  },
  {
    "tld": "ua",
    "server": "https://rdap.hostmaster.ua/"
  },
  {
    "tld": "int",
    "server": "https://rdap.iana.org/"
  },
  {
    "tld": "abb",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "abbott",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "abc",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "academy",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "accenture",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "accountants",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "actor",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "aeg",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "aero",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "agakhan",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "agency",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ai",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "airbus",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "airforce",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "akdn",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "alibaba",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "alipay",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "allstate",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "aol",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "apartments",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "apple",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "archi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "army",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "arte",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "asda",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "asia",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "associates",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "attorney",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "auction",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "audi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "band",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "barclaycard",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "barclays",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "barefoot",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bargains",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bbt",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bcg",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "beats",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bestbuy",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bet",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bike",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bingo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bio",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "black",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bloomberg",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "blue",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bm",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bms",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bnpparibas",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "boehringer",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bofa",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bosch",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "boutique",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "bradesco",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "broker",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "builders",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "business",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cab",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cafe",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "camera",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "camp",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "capital",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cards",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "care",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "careers",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cash",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "casino",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "catering",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "center",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cern",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cfa",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "chanel",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "chat",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cheap",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "church",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cipriani",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "citadel",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "city",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "claims",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cleaning",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "clinic",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "clinique",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "clothing",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "clubmed",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "coach",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "codes",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "coffee",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "community",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "company",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "computer",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "condos",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "construction",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "consulting",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "contact",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "contractors",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cool",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "coupon",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "coupons",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "credit",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "creditcard",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "crs",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cruise",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "cruises",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "dance",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "dating",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "deals",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "degree",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "delivery",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "delta",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "democrat",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "dental",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "dentist",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "diamonds",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "digital",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "direct",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "directory",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "discount",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "discover",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "doctor",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "dog",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "domains",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "dunlop",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "edeka",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "education",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "email",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "emerck",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "energy",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "engineer",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "engineering",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "enterprises",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "equipment",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ericsson",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "estate",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "events",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "exchange",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "expert",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "exposed",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "express",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "extraspace",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fage",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fail",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "family",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fan",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "farm",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fedex",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ferrari",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fidelity",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fido",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "finance",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "financial",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fish",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fitness",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "flights",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "florist",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "football",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "forex",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "forsale",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "frogans",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fund",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "furniture",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "futbol",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "fyi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gallery",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gallo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gallup",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "games",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "genting",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gifts",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "glass",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "global",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gmbh",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gold",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "golf",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "goodyear",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "graphics",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gratis",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "green",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "gripe",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "group",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "guide",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "guru",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "haus",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "hdfc",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "hdfcbank",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "healthcare",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "helsinki",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "hermes",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "hkt",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "hockey",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "holdings",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "holiday",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "homedepot",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "hospital",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "house",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "hughes",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ice",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "imamat",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "immo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "immobilien",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "industries",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "info",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "institute",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "insure",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "international",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "investments",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "irish",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ismaili",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ist",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "istanbul",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "itv",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "jaguar",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "java",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "jeep",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "jetzt",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "jewelry",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "jio",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "jll",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "juniper",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kaufen",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kerryhotels",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kerryproperties",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kids",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kim",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kitchen",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kosher",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "kuokgroup",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lamborghini",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lamer",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "land",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "landrover",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lasalle",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lawyer",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lds",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lease",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lefrak",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "legal",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lego",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lgbt",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "life",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lighting",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "limited",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "limo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "live",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "llc",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "loans",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lotto",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ltd",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ltda",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "lundbeck",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "maif",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "maison",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "management",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "market",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "marketing",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "markets",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "marriott",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "mba",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "mckinsey",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "media",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "memorial",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "mit",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "mobi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "moda",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "money",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "mormon",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "mortgage",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "movie",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "mu",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "nab",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "navy",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "network",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "news",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "next",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "nextdirect",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "nikon",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ninja",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "nowtv",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "nra",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "obi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "onl",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "oracle",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "orange",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "organic",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "origins",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "partners",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "parts",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pccw",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pet",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "photography",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "photos",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pictet",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pictures",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pink",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pizza",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "place",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "plumbing",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "plus",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pnc",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "poker",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "post",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pro",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "productions",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "progressive",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "promo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "properties",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pub",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "pwc",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "recipes",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "red",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "redumbrella",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rehab",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "reise",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "reisen",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "reliance",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rentals",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "repair",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "report",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "republican",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "restaurant",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "reviews",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rexroth",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rich",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "richardli",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ril",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rip",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rocks",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rogers",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "run",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "rwe",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "sale",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "salon",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "sanofi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "sarl",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "saxo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "sbi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "scholarships",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "school",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "schule",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "sener",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "services",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "sew",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "shangrila",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "shiksha",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "shoes",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "shopping",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "show",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "sina",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "singles",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ski",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "soccer",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "social",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "software",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "solar",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "solutions",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "song",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "spa",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "srl",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "stada",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "star",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "statebank",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "stockholm",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "studio",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "style",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "supplies",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "supply",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "support",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "surgery",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "systems",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "taobao",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tatamotors",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tax",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "taxi",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "team",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "technology",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "temasek",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tennis",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "thd",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "theater",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tiaa",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tienda",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tips",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tires",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tmall",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "today",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tools",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tours",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "town",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "toys",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "trading",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "training",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "travel",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "travelers",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "travelersinsurance",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "trv",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "tvs",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ubank",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ubs",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "university",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ups",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vacations",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vanguard",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vegas",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "ventures",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vet",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "viajes",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "video",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vig",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "viking",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "villas",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vin",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "visa",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vision",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "volvo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "vote",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "voto",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "voyage",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "watch",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "watches",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "weber",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "weibo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "weir",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "wine",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "wolterskluwer",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "works",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "world",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "wtf",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xin",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--1ck2e1b",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--5tzm5g",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--6frz82g",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--9krt00a",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--b4w605ferd",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--bck1b9a5dre4c",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--cck2b3b",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--czrs0t",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--eckvdtc9d",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--fct429k",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--fjq720a",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--fzys8d69uvgm",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--gckr3f0f",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--gk3at1e",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--jvr189m",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--rovu88b",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--unup4y",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "xn--vhquv",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "yahoo",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "zara",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "zero",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "zone",
    "server": "https://rdap.identitydigital.services/rdap/"
  },
  {
    "tld": "is",
    "server": "https://rdap.isnic.is/rdap/"
  },
  {
    "tld": "ke",
    "server": "https://rdap.kenic.or.ke/"
  },
  {
    "tld": "kiwi",
    "server": "https://rdap.kiwi.fury.ca/rdap/"
  },
  {
    "tld": "lb",
    "server": "https://rdap.lbdr.org.lb/"
  },
  {
    "tld": "mls",
    "server": "https://rdap.mls.fury.ca/rdap/"
  },
  {
    "tld": "blockbuster",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "data",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "dish",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "dot",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "dtv",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "dvr",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "latino",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "mobile",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "ollo",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "ott",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "phone",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "sling",
    "server": "https://rdap.mobile-registry.com/rdap/"
  },
  {
    "tld": "aaa",
    "server": "https://rdap.nic.aaa/"
  },
  {
    "tld": "aarp",
    "server": "https://rdap.nic.aarp/"
  },
  {
    "tld": "able",
    "server": "https://rdap.nic.able/"
  },
  {
    "tld": "abogado",
    "server": "https://rdap.nic.abogado/"
  },
  {
    "tld": "abudhabi",
    "server": "https://rdap.nic.abudhabi/"
  },
  {
    "tld": "accountant",
    "server": "https://rdap.nic.accountant/"
  },
  {
    "tld": "aco",
    "server": "https://rdap.nic.aco/"
  },
  {
    "tld": "ad",
    "server": "https://rdap.nic.ad/"
  },
  {
    "tld": "adult",
    "server": "https://rdap.nic.adult/"
  },
  {
    "tld": "aetna",
    "server": "https://rdap.nic.aetna/"
  },
  {
    "tld": "afl",
    "server": "https://rdap.nic.afl/"
  },
  {
    "tld": "africa",
    "server": "https://rdap.nic.africa/rdap/"
  },
  {
    "tld": "aig",
    "server": "https://rdap.nic.aig/"
  },
  {
    "tld": "ally",
    "server": "https://rdap.nic.ally/"
  },
  {
    "tld": "alsace",
    "server": "https://rdap.nic.alsace/"
  },
  {
    "tld": "alstom",
    "server": "https://rdap.nic.alstom/"
  },
  {
    "tld": "americanexpress",
    "server": "https://rdap.nic.americanexpress/"
  },
  {
    "tld": "americanfamily",
    "server": "https://rdap.nic.americanfamily/"
  },
  {
    "tld": "amex",
    "server": "https://rdap.nic.amex/"
  },
  {
    "tld": "amfam",
    "server": "https://rdap.nic.amfam/"
  },
  {
    "tld": "amica",
    "server": "https://rdap.nic.amica/"
  },
  {
    "tld": "amsterdam",
    "server": "https://rdap.nic.amsterdam/"
  },
  {
    "tld": "analytics",
    "server": "https://rdap.nic.analytics/"
  },
  {
    "tld": "anz",
    "server": "https://rdap.nic.anz/"
  },
  {
    "tld": "aquarelle",
    "server": "https://rdap.nic.aquarelle/"
  },
  {
    "tld": "ar",
    "server": "https://rdap.nic.ar/"
  },
  {
    "tld": "arab",
    "server": "https://rdap.nic.arab/"
  },
  {
    "tld": "aramco",
    "server": "https://rdap.nic.aramco/"
  },
  {
    "tld": "athleta",
    "server": "https://rdap.nic.athleta/"
  },
  {
    "tld": "auspost",
    "server": "https://rdap.nic.auspost/"
  },
  {
    "tld": "axa",
    "server": "https://rdap.nic.axa/"
  },
  {
    "tld": "banamex",
    "server": "https://rdap.nic.banamex/"
  },
  {
    "tld": "bank",
    "server": "https://rdap.nic.bank/"
  },
  {
    "tld": "barcelona",
    "server": "https://rdap.nic.barcelona/"
  },
  {
    "tld": "baseball",
    "server": "https://rdap.nic.baseball/"
  },
  {
    "tld": "basketball",
    "server": "https://rdap.nic.basketball/"
  },
  {
    "tld": "bauhaus",
    "server": "https://rdap.nic.bauhaus/"
  },
  {
    "tld": "bayern",
    "server": "https://rdap.nic.bayern/"
  },
  {
    "tld": "bcn",
    "server": "https://rdap.nic.bcn/"
  },
  {
    "tld": "beer",
    "server": "https://rdap.nic.beer/"
  },
  {
    "tld": "berlin",
    "server": "https://rdap.nic.berlin/v1/"
  },
  {
    "tld": "bible",
    "server": "https://rdap.nic.bible/"
  },
  {
    "tld": "bid",
    "server": "https://rdap.nic.bid/"
  },
  {
    "tld": "biz",
    "server": "https://rdap.nic.biz/"
  },
  {
    "tld": "blackfriday",
    "server": "https://rdap.nic.blackfriday/"
  },
  {
    "tld": "booking",
    "server": "https://rdap.nic.booking/"
  },
  {
    "tld": "bostik",
    "server": "https://rdap.nic.bostik/"
  },
  {
    "tld": "boston",
    "server": "https://rdap.nic.boston/"
  },
  {
    "tld": "brussels",
    "server": "https://rdap.nic.brussels/"
  },
  {
    "tld": "buzz",
    "server": "https://rdap.nic.buzz/"
  },
  {
    "tld": "bzh",
    "server": "https://rdap.nic.bzh/"
  },
  {
    "tld": "calvinklein",
    "server": "https://rdap.nic.calvinklein/"
  },
  {
    "tld": "capetown",
    "server": "https://rdap.nic.capetown/rdap/"
  },
  {
    "tld": "capitalone",
    "server": "https://rdap.nic.capitalone/"
  },
  {
    "tld": "caravan",
    "server": "https://rdap.nic.caravan/"
  },
  {
    "tld": "casa",
    "server": "https://rdap.nic.casa/"
  },
  {
    "tld": "cat",
    "server": "https://rdap.nic.cat/"
  },
  {
    "tld": "catholic",
    "server": "https://rdap.nic.catholic/"
  },
  {
    "tld": "cba",
    "server": "https://rdap.nic.cba/"
  },
  {
    "tld": "cbn",
    "server": "https://rdap.nic.cbn/"
  },
  {
    "tld": "cbre",
    "server": "https://rdap.nic.cbre/"
  },
  {
    "tld": "chase",
    "server": "https://rdap.nic.chase/"
  },
  {
    "tld": "chintai",
    "server": "https://rdap.nic.chintai/"
  },
  {
    "tld": "cisco",
    "server": "https://rdap.nic.cisco/"
  },
  {
    "tld": "citi",
    "server": "https://rdap.nic.citi/"
  },
  {
    "tld": "club",
    "server": "https://rdap.nic.club/"
  },
  {
    "tld": "cm",
    "server": "https://rdap.nic.cm/"
  },
  {
    "tld": "commbank",
    "server": "https://rdap.nic.commbank/"
  },
  {
    "tld": "compare",
    "server": "https://rdap.nic.compare/"
  },
  {
    "tld": "cooking",
    "server": "https://rdap.nic.cooking/"
  },
  {
    "tld": "corsica",
    "server": "https://rdap.nic.corsica/"
  },
  {
    "tld": "courses",
    "server": "https://rdap.nic.courses/"
  },
  {
    "tld": "cpa",
    "server": "https://rdap.nic.cpa/"
  },
  {
    "tld": "cr",
    "server": "https://rdap.nic.cr/"
  },
  {
    "tld": "cricket",
    "server": "https://rdap.nic.cricket/"
  },
  {
    "tld": "cuisinella",
    "server": "https://rdap.nic.cuisinella/"
  },
  {
    "tld": "cv",
    "server": "https://rdap.nic.cv/"
  },
  {
    "tld": "cx",
    "server": "https://rdap.nic.cx/"
  },
  {
    "tld": "cz",
    "server": "https://rdap.nic.cz/"
  },
  {
    "tld": "date",
    "server": "https://rdap.nic.date/"
  },
  {
    "tld": "dds",
    "server": "https://rdap.nic.dds/"
  },
  {
    "tld": "dell",
    "server": "https://rdap.nic.dell/"
  },
  {
    "tld": "design",
    "server": "https://rdap.nic.design/"
  },
  {
    "tld": "diy",
    "server": "https://rdap.nic.diy/rdap/"
  },
  {
    "tld": "download",
    "server": "https://rdap.nic.download/"
  },
  {
    "tld": "dubai",
    "server": "https://rdap.nic.dubai/"
  },
  {
    "tld": "dupont",
    "server": "https://rdap.nic.dupont/"
  },
  {
    "tld": "durban",
    "server": "https://rdap.nic.durban/rdap/"
  },
  {
    "tld": "earth",
    "server": "https://rdap.nic.earth/"
  },
  {
    "tld": "erni",
    "server": "https://rdap.nic.erni/"
  },
  {
    "tld": "eurovision",
    "server": "https://rdap.nic.eurovision/"
  },
  {
    "tld": "eus",
    "server": "https://rdap.nic.eus/"
  },
  {
    "tld": "faith",
    "server": "https://rdap.nic.faith/"
  },
  {
    "tld": "farmers",
    "server": "https://rdap.nic.farmers/"
  },
  {
    "tld": "fashion",
    "server": "https://rdap.nic.fashion/"
  },
  {
    "tld": "feedback",
    "server": "https://rdap.nic.feedback/rdap/"
  },
  {
    "tld": "ferrero",
    "server": "https://rdap.nic.ferrero/"
  },
  {
    "tld": "film",
    "server": "https://rdap.nic.film/"
  },
  {
    "tld": "firmdale",
    "server": "https://rdap.nic.firmdale/"
  },
  {
    "tld": "fishing",
    "server": "https://rdap.nic.fishing/"
  },
  {
    "tld": "fit",
    "server": "https://rdap.nic.fit/"
  },
  {
    "tld": "flickr",
    "server": "https://rdap.nic.flickr/"
  },
  {
    "tld": "flir",
    "server": "https://rdap.nic.flir/"
  },
  {
    "tld": "food",
    "server": "https://rdap.nic.food/rdap/"
  },
  {
    "tld": "ford",
    "server": "https://rdap.nic.ford/"
  },
  {
    "tld": "forum",
    "server": "https://rdap.nic.forum/rdap/"
  },
  {
    "tld": "fox",
    "server": "https://rdap.nic.fox/"
  },
  {
    "tld": "fr",
    "server": "https://rdap.nic.fr/"
  },
  {
    "tld": "frontier",
    "server": "https://rdap.nic.frontier/"
  },
  {
    "tld": "ftr",
    "server": "https://rdap.nic.ftr/"
  },
  {
    "tld": "gal",
    "server": "https://rdap.nic.gal/"
  },
  {
    "tld": "gap",
    "server": "https://rdap.nic.gap/"
  },
  {
    "tld": "garden",
    "server": "https://rdap.nic.garden/"
  },
  {
    "tld": "gay",
    "server": "https://rdap.nic.gay/"
  },
  {
    "tld": "gdn",
    "server": "https://rdap.nic.gdn/"
  },
  {
    "tld": "gea",
    "server": "https://rdap.nic.gea/"
  },
  {
    "tld": "george",
    "server": "https://rdap.nic.george/"
  },
  {
    "tld": "gmx",
    "server": "https://rdap.nic.gmx/"
  },
  {
    "tld": "godaddy",
    "server": "https://rdap.nic.godaddy/"
  },
  {
    "tld": "grainger",
    "server": "https://rdap.nic.grainger/"
  },
  {
    "tld": "grocery",
    "server": "https://rdap.nic.grocery/"
  },
  {
    "tld": "gs",
    "server": "https://rdap.nic.gs/"
  },
  {
    "tld": "hamburg",
    "server": "https://rdap.nic.hamburg/v1/"
  },
  {
    "tld": "hbo",
    "server": "https://rdap.nic.hbo/"
  },
  {
    "tld": "health",
    "server": "https://rdap.nic.health/"
  },
  {
    "tld": "hn",
    "server": "https://rdap.nic.hn/"
  },
  {
    "tld": "homegoods",
    "server": "https://rdap.nic.homegoods/"
  },
  {
    "tld": "homesense",
    "server": "https://rdap.nic.homesense/"
  },
  {
    "tld": "horse",
    "server": "https://rdap.nic.horse/"
  },
  {
    "tld": "hotels",
    "server": "https://rdap.nic.hotels/"
  },
  {
    "tld": "hsbc",
    "server": "https://rdap.nic.hsbc/"
  },
  {
    "tld": "ht",
    "server": "https://rdap.nic.ht/"
  },
  {
    "tld": "hyatt",
    "server": "https://rdap.nic.hyatt/"
  },
  {
    "tld": "ibm",
    "server": "https://rdap.nic.ibm/"
  },
  {
    "tld": "ifm",
    "server": "https://rdap.nic.ifm/"
  },
  {
    "tld": "ikano",
    "server": "https://rdap.nic.ikano/v1/"
  },
  {
    "tld": "ink",
    "server": "https://rdap.nic.ink/"
  },
  {
    "tld": "insurance",
    "server": "https://rdap.nic.insurance/"
  },
  {
    "tld": "intuit",
    "server": "https://rdap.nic.intuit/"
  },
  {
    "tld": "ipiranga",
    "server": "https://rdap.nic.ipiranga/"
  },
  {
    "tld": "itau",
    "server": "https://rdap.nic.itau/"
  },
  {
    "tld": "jmp",
    "server": "https://rdap.nic.jmp/"
  },
  {
    "tld": "joburg",
    "server": "https://rdap.nic.joburg/rdap/"
  },
  {
    "tld": "jpmorgan",
    "server": "https://rdap.nic.jpmorgan/"
  },
  {
    "tld": "jprs",
    "server": "https://rdap.nic.jprs/rdap/"
  },
  {
    "tld": "kpmg",
    "server": "https://rdap.nic.kpmg/"
  },
  {
    "tld": "krd",
    "server": "https://rdap.nic.krd/"
  },
  {
    "tld": "lacaixa",
    "server": "https://rdap.nic.lacaixa/"
  },
  {
    "tld": "lanxess",
    "server": "https://rdap.nic.lanxess/"
  },
  {
    "tld": "latrobe",
    "server": "https://rdap.nic.latrobe/"
  },
  {
    "tld": "law",
    "server": "https://rdap.nic.law/"
  },
  {
    "tld": "leclerc",
    "server": "https://rdap.nic.leclerc/"
  },
  {
    "tld": "lifeinsurance",
    "server": "https://rdap.nic.lifeinsurance/"
  },
  {
    "tld": "lifestyle",
    "server": "https://rdap.nic.lifestyle/rdap/"
  },
  {
    "tld": "lilly",
    "server": "https://rdap.nic.lilly/"
  },
  {
    "tld": "lincoln",
    "server": "https://rdap.nic.lincoln/"
  },
  {
    "tld": "living",
    "server": "https://rdap.nic.living/rdap/"
  },
  {
    "tld": "loan",
    "server": "https://rdap.nic.loan/"
  },
  {
    "tld": "locker",
    "server": "https://rdap.nic.locker/rdap/"
  },
  {
    "tld": "luxe",
    "server": "https://rdap.nic.luxe/"
  },
  {
    "tld": "ly",
    "server": "https://rdap.nic.ly/"
  },
  {
    "tld": "madrid",
    "server": "https://rdap.nic.madrid/"
  },
  {
    "tld": "man",
    "server": "https://rdap.nic.man/"
  },
  {
    "tld": "mango",
    "server": "https://rdap.nic.mango/"
  },
  {
    "tld": "marshalls",
    "server": "https://rdap.nic.marshalls/"
  },
  {
    "tld": "mattel",
    "server": "https://rdap.nic.mattel/"
  },
  {
    "tld": "melbourne",
    "server": "https://rdap.nic.melbourne/"
  },
  {
    "tld": "men",
    "server": "https://rdap.nic.men/"
  },
  {
    "tld": "menu",
    "server": "https://rdap.nic.menu/"
  },
  {
    "tld": "merckmsd",
    "server": "https://rdap.nic.merckmsd/"
  },
  {
    "tld": "miami",
    "server": "https://rdap.nic.miami/"
  },
  {
    "tld": "mint",
    "server": "https://rdap.nic.mint/"
  },
  {
    "tld": "ml",
    "server": "https://rdap.nic.ml/"
  },
  {
    "tld": "mlb",
    "server": "https://rdap.nic.mlb/"
  },
  {
    "tld": "mma",
    "server": "https://rdap.nic.mma/"
  },
  {
    "tld": "moe",
    "server": "https://rdap.nic.moe/"
  },
  {
    "tld": "monash",
    "server": "https://rdap.nic.monash/"
  },
  {
    "tld": "moto",
    "server": "https://rdap.nic.moto/"
  },
  {
    "tld": "ms",
    "server": "https://rdap.nic.ms/"
  },
  {
    "tld": "msd",
    "server": "https://rdap.nic.msd/"
  },
  {
    "tld": "museum",
    "server": "https://rdap.nic.museum/"
  },
  {
    "tld": "nba",
    "server": "https://rdap.nic.nba/"
  },
  {
    "tld": "netbank",
    "server": "https://rdap.nic.netbank/"
  },
  {
    "tld": "netflix",
    "server": "https://rdap.nic.netflix/"
  },
  {
    "tld": "neustar",
    "server": "https://rdap.nic.neustar/"
  },
  {
    "tld": "nf",
    "server": "https://rdap.nic.nf/"
  },
  {
    "tld": "nfl",
    "server": "https://rdap.nic.nfl/"
  },
  {
    "tld": "nike",
    "server": "https://rdap.nic.nike/"
  },
  {
    "tld": "norton",
    "server": "https://rdap.nic.norton/"
  },
  {
    "tld": "nrw",
    "server": "https://rdap.nic.nrw/"
  },
  {
    "tld": "ntt",
    "server": "https://rdap.nic.ntt/rdap/"
  },
  {
    "tld": "nyc",
    "server": "https://rdap.nic.nyc/"
  },
  {
    "tld": "olayan",
    "server": "https://rdap.nic.olayan/"
  },
  {
    "tld": "olayangroup",
    "server": "https://rdap.nic.olayangroup/"
  },
  {
    "tld": "one",
    "server": "https://rdap.nic.one/"
  },
  {
    "tld": "open",
    "server": "https://rdap.nic.open/"
  },
  {
    "tld": "osaka",
    "server": "https://rdap.nic.osaka/"
  },
  {
    "tld": "ovh",
    "server": "https://rdap.nic.ovh/"
  },
  {
    "tld": "paris",
    "server": "https://rdap.nic.paris/"
  },
  {
    "tld": "party",
    "server": "https://rdap.nic.party/"
  },
  {
    "tld": "pfizer",
    "server": "https://rdap.nic.pfizer/"
  },
  {
    "tld": "pg",
    "server": "https://rdap.nic.pg/"
  },
  {
    "tld": "philips",
    "server": "https://rdap.nic.philips/"
  },
  {
    "tld": "photo",
    "server": "https://rdap.nic.photo/"
  },
  {
    "tld": "physio",
    "server": "https://rdap.nic.physio/"
  },
  {
    "tld": "pid",
    "server": "https://rdap.nic.pid/rdap/"
  },
  {
    "tld": "ping",
    "server": "https://rdap.nic.ping/"
  },
  {
    "tld": "pm",
    "server": "https://rdap.nic.pm/"
  },
  {
    "tld": "politie",
    "server": "https://rdap.nic.politie/"
  },
  {
    "tld": "porn",
    "server": "https://rdap.nic.porn/"
  },
  {
    "tld": "praxi",
    "server": "https://rdap.nic.praxi/"
  },
  {
    "tld": "pru",
    "server": "https://rdap.nic.pru/"
  },
  {
    "tld": "prudential",
    "server": "https://rdap.nic.prudential/"
  },
  {
    "tld": "quebec",
    "server": "https://rdap.nic.quebec/"
  },
  {
    "tld": "racing",
    "server": "https://rdap.nic.racing/"
  },
  {
    "tld": "radio",
    "server": "https://rdap.nic.radio/"
  },
  {
    "tld": "re",
    "server": "https://rdap.nic.re/"
  },
  {
    "tld": "review",
    "server": "https://rdap.nic.review/"
  },
  {
    "tld": "rodeo",
    "server": "https://rdap.nic.rodeo/"
  },
  {
    "tld": "rugby",
    "server": "https://rdap.nic.rugby/"
  },
  {
    "tld": "safety",
    "server": "https://rdap.nic.safety/"
  },
  {
    "tld": "sakura",
    "server": "https://rdap.nic.sakura/rdap/"
  },
  {
    "tld": "samsclub",
    "server": "https://rdap.nic.samsclub/"
  },
  {
    "tld": "sandvik",
    "server": "https://rdap.nic.sandvik/"
  },
  {
    "tld": "sandvikcoromant",
    "server": "https://rdap.nic.sandvikcoromant/"
  },
  {
    "tld": "sap",
    "server": "https://rdap.nic.sap/"
  },
  {
    "tld": "sas",
    "server": "https://rdap.nic.sas/"
  },
  {
    "tld": "scb",
    "server": "https://rdap.nic.scb/"
  },
  {
    "tld": "schaeffler",
    "server": "https://rdap.nic.schaeffler/"
  },
  {
    "tld": "schmidt",
    "server": "https://rdap.nic.schmidt/"
  },
  {
    "tld": "science",
    "server": "https://rdap.nic.science/"
  },
  {
    "tld": "scot",
    "server": "https://rdap.nic.scot/"
  },
  {
    "tld": "sd",
    "server": "https://rdap.nic.sd/"
  },
  {
    "tld": "seat",
    "server": "https://rdap.nic.seat/"
  },
  {
    "tld": "seek",
    "server": "https://rdap.nic.seek/"
  },
  {
    "tld": "select",
    "server": "https://rdap.nic.select/"
  },
  {
    "tld": "seven",
    "server": "https://rdap.nic.seven/"
  },
  {
    "tld": "sex",
    "server": "https://rdap.nic.sex/"
  },
  {
    "tld": "sncf",
    "server": "https://rdap.nic.sncf/"
  },
  {
    "tld": "sport",
    "server": "https://rdap.nic.sport/"
  },
  {
    "tld": "ss",
    "server": "https://rdap.nic.ss/"
  },
  {
    "tld": "staples",
    "server": "https://rdap.nic.staples/"
  },
  {
    "tld": "statefarm",
    "server": "https://rdap.nic.statefarm/"
  },
  {
    "tld": "stream",
    "server": "https://rdap.nic.stream/"
  },
  {
    "tld": "study",
    "server": "https://rdap.nic.study/"
  },
  {
    "tld": "sucks",
    "server": "https://rdap.nic.sucks/"
  },
  {
    "tld": "surf",
    "server": "https://rdap.nic.surf/"
  },
  {
    "tld": "swiss",
    "server": "https://rdap.nic.swiss/"
  },
  {
    "tld": "sydney",
    "server": "https://rdap.nic.sydney/"
  },
  {
    "tld": "tab",
    "server": "https://rdap.nic.tab/"
  },
  {
    "tld": "taipei",
    "server": "https://rdap.nic.taipei/"
  },
  {
    "tld": "target",
    "server": "https://rdap.nic.target/"
  },
  {
    "tld": "tattoo",
    "server": "https://rdap.nic.tattoo/"
  },
  {
    "tld": "tdk",
    "server": "https://rdap.nic.tdk/"
  },
  {
    "tld": "tel",
    "server": "https://rdap.nic.tel/"
  },
  {
    "tld": "teva",
    "server": "https://rdap.nic.teva/"
  },
  {
    "tld": "tf",
    "server": "https://rdap.nic.tf/"
  },
  {
    "tld": "tjmaxx",
    "server": "https://rdap.nic.tjmaxx/"
  },
  {
    "tld": "tjx",
    "server": "https://rdap.nic.tjx/"
  },
  {
    "tld": "tkmaxx",
    "server": "https://rdap.nic.tkmaxx/"
  },
  {
    "tld": "total",
    "server": "https://rdap.nic.total/"
  },
  {
    "tld": "trade",
    "server": "https://rdap.nic.trade/"
  },
  {
    "tld": "tube",
    "server": "https://rdap.nic.tube/"
  },
  {
    "tld": "tv",
    "server": "https://rdap.nic.tv/"
  },
  {
    "tld": "vana",
    "server": "https://rdap.nic.vana/rdap/"
  },
  {
    "tld": "versicherung",
    "server": "https://rdap.nic.versicherung/v1/"
  },
  {
    "tld": "vi",
    "server": "https://rdap.nic.vi/"
  },
  {
    "tld": "vip",
    "server": "https://rdap.nic.vip/"
  },
  {
    "tld": "vivo",
    "server": "https://rdap.nic.vivo/"
  },
  {
    "tld": "vlaanderen",
    "server": "https://rdap.nic.vlaanderen/"
  },
  {
    "tld": "vodka",
    "server": "https://rdap.nic.vodka/"
  },
  {
    "tld": "voting",
    "server": "https://rdap.nic.voting/"
  },
  {
    "tld": "walmart",
    "server": "https://rdap.nic.walmart/"
  },
  {
    "tld": "walter",
    "server": "https://rdap.nic.walter/"
  },
  {
    "tld": "weather",
    "server": "https://rdap.nic.weather/"
  },
  {
    "tld": "weatherchannel",
    "server": "https://rdap.nic.weatherchannel/"
  },
  {
    "tld": "webcam",
    "server": "https://rdap.nic.webcam/"
  },
  {
    "tld": "wedding",
    "server": "https://rdap.nic.wedding/"
  },
  {
    "tld": "wf",
    "server": "https://rdap.nic.wf/"
  },
  {
    "tld": "whoswho",
    "server": "https://rdap.nic.whoswho/"
  },
  {
    "tld": "wiki",
    "server": "https://rdap.nic.wiki/"
  },
  {
    "tld": "williamhill",
    "server": "https://rdap.nic.williamhill/"
  },
  {
    "tld": "win",
    "server": "https://rdap.nic.win/"
  },
  {
    "tld": "winners",
    "server": "https://rdap.nic.winners/"
  },
  {
    "tld": "woodside",
    "server": "https://rdap.nic.woodside/"
  },
  {
    "tld": "work",
    "server": "https://rdap.nic.work/"
  },
  {
    "tld": "wtc",
    "server": "https://rdap.nic.wtc/"
  },
  {
    "tld": "xerox",
    "server": "https://rdap.nic.xerox/"
  },
  {
    "tld": "xn--80aqecdr1a",
    "server": "https://rdap.nic.xn--80aqecdr1a/"
  },
  {
    "tld": "xn--80asehdb",
    "server": "https://rdap.nic.xn--80asehdb/"
  },
  {
    "tld": "xn--80aswg",
    "server": "https://rdap.nic.xn--80aswg/"
  },
  {
    "tld": "xn--g2xx48c",
    "server": "https://rdap.nic.xn--g2xx48c/"
  },
  {
    "tld": "xn--kcrx77d1x4a",
    "server": "https://rdap.nic.xn--kcrx77d1x4a/"
  },
  {
    "tld": "xn--mgba3a3ejt",
    "server": "https://rdap.nic.xn--mgba3a3ejt/"
  },
  {
    "tld": "xn--mgba7c0bbn0a",
    "server": "https://rdap.nic.xn--mgba7c0bbn0a/"
  },
  {
    "tld": "xn--mgbab2bd",
    "server": "https://rdap.nic.xn--mgbab2bd/"
  },
  {
    "tld": "xn--mgbca7dzdo",
    "server": "https://rdap.nic.xn--mgbca7dzdo/"
  },
  {
    "tld": "xn--mgbi4ecexp",
    "server": "https://rdap.nic.xn--mgbi4ecexp/"
  },
  {
    "tld": "xn--ngbc5azd",
    "server": "https://rdap.nic.xn--ngbc5azd/"
  },
  {
    "tld": "xn--ngbrx",
    "server": "https://rdap.nic.xn--ngbrx/"
  },
  {
    "tld": "xn--tiq49xqyj",
    "server": "https://rdap.nic.xn--tiq49xqyj/"
  },
  {
    "tld": "xxx",
    "server": "https://rdap.nic.xxx/"
  },
  {
    "tld": "yandex",
    "server": "https://rdap.nic.yandex/rdap/"
  },
  {
    "tld": "yoga",
    "server": "https://rdap.nic.yoga/"
  },
  {
    "tld": "yt",
    "server": "https://rdap.nic.yt/"
  },
  {
    "tld": "zm",
    "server": "https://rdap.nic.zm/"
  },
  {
    "tld": "in",
    "server": "https://rdap.nixiregistry.in/rdap/"
  },
  {
    "tld": "abbvie",
    "server": "https://rdap.nominet.uk/abbvie/"
  },
  {
    "tld": "amazon",
    "server": "https://rdap.nominet.uk/amazon/"
  },
  {
    "tld": "audible",
    "server": "https://rdap.nominet.uk/audible/"
  },
  {
    "tld": "author",
    "server": "https://rdap.nominet.uk/author/"
  },
  {
    "tld": "aws",
    "server": "https://rdap.nominet.uk/aws/"
  },
  {
    "tld": "azure",
    "server": "https://rdap.nominet.uk/azure/"
  },
  {
    "tld": "bbc",
    "server": "https://rdap.nominet.uk/bbc/"
  },
  {
    "tld": "bbva",
    "server": "https://rdap.nominet.uk/bbva/"
  },
  {
    "tld": "bing",
    "server": "https://rdap.nominet.uk/bing/"
  },
  {
    "tld": "book",
    "server": "https://rdap.nominet.uk/book/"
  },
  {
    "tld": "bot",
    "server": "https://rdap.nominet.uk/bot/"
  },
  {
    "tld": "broadway",
    "server": "https://rdap.nominet.uk/broadway/"
  },
  {
    "tld": "buy",
    "server": "https://rdap.nominet.uk/buy/"
  },
  {
    "tld": "call",
    "server": "https://rdap.nominet.uk/call/"
  },
  {
    "tld": "career",
    "server": "https://rdap.nominet.uk/career/"
  },
  {
    "tld": "circle",
    "server": "https://rdap.nominet.uk/circle/"
  },
  {
    "tld": "cymru",
    "server": "https://rdap.nominet.uk/cymru/"
  },
  {
    "tld": "deal",
    "server": "https://rdap.nominet.uk/deal/"
  },
  {
    "tld": "desi",
    "server": "https://rdap.nominet.uk/desi/"
  },
  {
    "tld": "fairwinds",
    "server": "https://rdap.nominet.uk/fairwinds/"
  },
  {
    "tld": "fast",
    "server": "https://rdap.nominet.uk/fast/"
  },
  {
    "tld": "fire",
    "server": "https://rdap.nominet.uk/fire/"
  },
  {
    "tld": "free",
    "server": "https://rdap.nominet.uk/free/"
  },
  {
    "tld": "gop",
    "server": "https://rdap.nominet.uk/gop/"
  },
  {
    "tld": "got",
    "server": "https://rdap.nominet.uk/got/"
  },
  {
    "tld": "gucci",
    "server": "https://rdap.nominet.uk/gucci/"
  },
  {
    "tld": "hot",
    "server": "https://rdap.nominet.uk/hot/"
  },
  {
    "tld": "hotmail",
    "server": "https://rdap.nominet.uk/hotmail/"
  },
  {
    "tld": "ieee",
    "server": "https://rdap.nominet.uk/ieee/"
  },
  {
    "tld": "imdb",
    "server": "https://rdap.nominet.uk/imdb/"
  },
  {
    "tld": "jobs",
    "server": "https://rdap.nominet.uk/jobs/"
  },
  {
    "tld": "jot",
    "server": "https://rdap.nominet.uk/jot/"
  },
  {
    "tld": "joy",
    "server": "https://rdap.nominet.uk/joy/"
  },
  {
    "tld": "kindle",
    "server": "https://rdap.nominet.uk/kindle/"
  },
  {
    "tld": "like",
    "server": "https://rdap.nominet.uk/like/"
  },
  {
    "tld": "locus",
    "server": "https://rdap.nominet.uk/locus/"
  },
  {
    "tld": "med",
    "server": "https://rdap.nominet.uk/med/"
  },
  {
    "tld": "microsoft",
    "server": "https://rdap.nominet.uk/microsoft/"
  },
  {
    "tld": "moi",
    "server": "https://rdap.nominet.uk/moi/"
  },
  {
    "tld": "mtn",
    "server": "https://rdap.nominet.uk/mtn/"
  },
  {
    "tld": "now",
    "server": "https://rdap.nominet.uk/now/"
  },
  {
    "tld": "nowruz",
    "server": "https://rdap.nominet.uk/nowruz/"
  },
  {
    "tld": "office",
    "server": "https://rdap.nominet.uk/office/"
  },
  {
    "tld": "omega",
    "server": "https://rdap.nominet.uk/omega/"
  },
  {
    "tld": "pars",
    "server": "https://rdap.nominet.uk/pars/"
  },
  {
    "tld": "pay",
    "server": "https://rdap.nominet.uk/pay/"
  },
  {
    "tld": "pharmacy",
    "server": "https://rdap.nominet.uk/pharmacy/"
  },
  {
    "tld": "pin",
    "server": "https://rdap.nominet.uk/pin/"
  },
  {
    "tld": "pioneer",
    "server": "https://rdap.nominet.uk/pioneer/"
  },
  {
    "tld": "pn",
    "server": "https://rdap.nominet.uk/pn/"
  },
  {
    "tld": "prime",
    "server": "https://rdap.nominet.uk/prime/"
  },
  {
    "tld": "read",
    "server": "https://rdap.nominet.uk/read/"
  },
  {
    "tld": "realestate",
    "server": "https://rdap.nominet.uk/realestate/"
  },
  {
    "tld": "realtor",
    "server": "https://rdap.nominet.uk/realtor/"
  },
  {
    "tld": "room",
    "server": "https://rdap.nominet.uk/room/"
  },
  {
    "tld": "safe",
    "server": "https://rdap.nominet.uk/safe/"
  },
  {
    "tld": "save",
    "server": "https://rdap.nominet.uk/save/"
  },
  {
    "tld": "secure",
    "server": "https://rdap.nominet.uk/secure/"
  },
  {
    "tld": "shell",
    "server": "https://rdap.nominet.uk/shell/"
  },
  {
    "tld": "shia",
    "server": "https://rdap.nominet.uk/shia/"
  },
  {
    "tld": "silk",
    "server": "https://rdap.nominet.uk/silk/"
  },
  {
    "tld": "sky",
    "server": "https://rdap.nominet.uk/sky/"
  },
  {
    "tld": "skype",
    "server": "https://rdap.nominet.uk/skype/"
  },
  {
    "tld": "smile",
    "server": "https://rdap.nominet.uk/smile/"
  },
  {
    "tld": "spot",
    "server": "https://rdap.nominet.uk/spot/"
  },
  {
    "tld": "swatch",
    "server": "https://rdap.nominet.uk/swatch/"
  },
  {
    "tld": "talk",
    "server": "https://rdap.nominet.uk/talk/"
  },
  {
    "tld": "tci",
    "server": "https://rdap.nominet.uk/tci/"
  },
  {
    "tld": "tunes",
    "server": "https://rdap.nominet.uk/tunes/"
  },
  {
    "tld": "tushu",
    "server": "https://rdap.nominet.uk/tushu/"
  },
  {
    "tld": "uk",
    "server": "https://rdap.nominet.uk/uk/"
  },
  {
    "tld": "virgin",
    "server": "https://rdap.nominet.uk/virgin/"
  },
  {
    "tld": "wales",
    "server": "https://rdap.nominet.uk/wales/"
  },
  {
    "tld": "wanggou",
    "server": "https://rdap.nominet.uk/wanggou/"
  },
  {
    "tld": "wed",
    "server": "https://rdap.nominet.uk/wed/"
  },
  {
    "tld": "windows",
    "server": "https://rdap.nominet.uk/windows/"
  },
  {
    "tld": "wow",
    "server": "https://rdap.nominet.uk/wow/"
  },
  {
    "tld": "xbox",
    "server": "https://rdap.nominet.uk/xbox/"
  },
  {
    "tld": "xn--cckwcxetd",
    "server": "https://rdap.nominet.uk/xn--cckwcxetd/"
  },
  {
    "tld": "xn--jlq480n2rg",
    "server": "https://rdap.nominet.uk/xn--jlq480n2rg/"
  },
  {
    "tld": "xn--mgbt3dhd",
    "server": "https://rdap.nominet.uk/xn--mgbt3dhd/"
  },
  {
    "tld": "yamaxun",
    "server": "https://rdap.nominet.uk/yamaxun/"
  },
  {
    "tld": "you",
    "server": "https://rdap.nominet.uk/you/"
  },
  {
    "tld": "zappos",
    "server": "https://rdap.nominet.uk/zappos/"
  },
  {
    "tld": "no",
    "server": "https://rdap.norid.no/"
  },
  {
    "tld": "id",
    "server": "https://rdap.pandi.id/rdap/"
  },
  {
    "tld": "charity",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "foundation",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "gives",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "giving",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "ngo",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "ong",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "org",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "xn--c1avg",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "xn--i1b6b1a6a2e",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "xn--nqv7f",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "xn--nqv7fs00ema",
    "server": "https://rdap.publicinterestregistry.org/rdap/"
  },
  {
    "tld": "si",
    "server": "https://rdap.register.si/"
  },
  {
    "tld": "br",
    "server": "https://rdap.registro.br/"
  },
  {
    "tld": "bar",
    "server": "https://rdap.registry.bar/rdap/"
  },
  {
    "tld": "rest",
    "server": "https://rdap.registry.bar/rdap/"
  },
  {
    "tld": "observer",
    "server": "https://rdap.registry.click/rdap/"
  },
  {
    "tld": "realty",
    "server": "https://rdap.registry.click/rdap/"
  },
  {
    "tld": "cloud",
    "server": "https://rdap.registry.cloud/rdap/"
  },
  {
    "tld": "coop",
    "server": "https://rdap.registry.coop/rdap/"
  },
  {
    "tld": "creditunion",
    "server": "https://rdap.registry.coop/rdap/"
  },
  {
    "tld": "ec",
    "server": "https://rdap.registry.ec/"
  },
  {
    "tld": "gy",
    "server": "https://rdap.registry.gy/"
  },
  {
    "tld": "hiphop",
    "server": "https://rdap.registry.hiphop/rdap/"
  },
  {
    "tld": "love",
    "server": "https://rdap.registry.love/rdap/"
  },
  {
    "tld": "music",
    "server": "https://rdap.registryservices.music/rdap/"
  },
  {
    "tld": "rw",
    "server": "https://rdap.ricta.org.rw/"
  },
  {
    "tld": "cologne",
    "server": "https://rdap.ryce-rsp.com/rdap/"
  },
  {
    "tld": "koeln",
    "server": "https://rdap.ryce-rsp.com/rdap/"
  },
  {
    "tld": "tirol",
    "server": "https://rdap.ryce-rsp.com/rdap/"
  },
  {
    "tld": "wien",
    "server": "https://rdap.ryce-rsp.com/rdap/"
  },
  {
    "tld": "nl",
    "server": "https://rdap.sidn.nl/"
  },
  {
    "tld": "anquan",
    "server": "https://rdap.teleinfo.cn/"
  },
  {
    "tld": "shouji",
    "server": "https://rdap.teleinfo.cn/"
  },
  {
    "tld": "xihuan",
    "server": "https://rdap.teleinfo.cn/"
  },
  {
    "tld": "xn--vuq861b",
    "server": "https://rdap.teleinfo.cn/"
  },
  {
    "tld": "yun",
    "server": "https://rdap.teleinfo.cn/"
  },
  {
    "tld": "xn--3ds443g",
    "server": "https://rdap.teleinfo.cn/xn--3ds443g/"
  },
  {
    "tld": "xn--fiq228c5hs",
    "server": "https://rdap.teleinfo.cn/xn--fiq228c5hs/"
  },
  {
    "tld": "xn--kput3i",
    "server": "https://rdap.teleinfo.cn/xn--kput3i/"
  },
  {
    "tld": "xn--nyqy26a",
    "server": "https://rdap.teleinfo.cn/xn--nyqy26a/"
  },
  {
    "tld": "xn--rhqv96g",
    "server": "https://rdap.teleinfo.cn/xn--rhqv96g/"
  },
  {
    "tld": "th",
    "server": "https://rdap.thains.co.th/"
  },
  {
    "tld": "xn--o3cw4h",
    "server": "https://rdap.thains.co.th/"
  },
  {
    "tld": "to",
    "server": "https://rdap.tonicregistry.to/rdap/"
  },
  {
    "tld": "xn--mxtq1m",
    "server": "https://rdap.twnic.tw/rdap/"
  },
  {
    "tld": "com",
    "server": "https://rdap.verisign.com/com/v1/"
  },
  {
    "tld": "net",
    "server": "https://rdap.verisign.com/net/v1/"
  },
  {
    "tld": "ye",
    "server": "https://rdap.y.net.ye/"
  },
  {
    "tld": "xn--45q11c",
    "server": "https://rdap.zdnsgtld.com/XN--45Q11C/"
  },
  {
    "tld": "xn--efvy88h",
    "server": "https://rdap.zdnsgtld.com/XN--EFVY88H/"
  },
  {
    "tld": "baidu",
    "server": "https://rdap.zdnsgtld.com/baidu/"
  },
  {
    "tld": "citic",
    "server": "https://rdap.zdnsgtld.com/citic/"
  },
  {
    "tld": "icbc",
    "server": "https://rdap.zdnsgtld.com/icbc/"
  },
  {
    "tld": "ren",
    "server": "https://rdap.zdnsgtld.com/ren/"
  },
  {
    "tld": "sohu",
    "server": "https://rdap.zdnsgtld.com/sohu/"
  },
  {
    "tld": "top",
    "server": "https://rdap.zdnsgtld.com/top/"
  },
  {
    "tld": "unicom",
    "server": "https://rdap.zdnsgtld.com/unicom/"
  },
  {
    "tld": "wang",
    "server": "https://rdap.zdnsgtld.com/wang/"
  },
  {
    "tld": "xn--30rr7y",
    "server": "https://rdap.zdnsgtld.com/xn--30rr7y/"
  },
  {
    "tld": "xn--3bst00m",
    "server": "https://rdap.zdnsgtld.com/xn--3bst00m/"
  },
  {
    "tld": "xn--6qq986b3xl",
    "server": "https://rdap.zdnsgtld.com/xn--6qq986b3xl/"
  },
  {
    "tld": "xn--8y0a063a",
    "server": "https://rdap.zdnsgtld.com/xn--8y0a063a/"
  },
  {
    "tld": "xn--9et52u",
    "server": "https://rdap.zdnsgtld.com/xn--9et52u/"
  },
  {
    "tld": "xn--czr694b",
    "server": "https://rdap.zdnsgtld.com/xn--czr694b/"
  },
  {
    "tld": "xn--czru2d",
    "server": "https://rdap.zdnsgtld.com/xn--czru2d/"
  },
  {
    "tld": "xn--fiq64b",
    "server": "https://rdap.zdnsgtld.com/xn--fiq64b/"
  },
  {
    "tld": "xn--hxt814e",
    "server": "https://rdap.zdnsgtld.com/xn--hxt814e/"
  },
  {
    "tld": "xn--imr513n",
    "server": "https://rdap.zdnsgtld.com/xn--imr513n/"
  },
  {
    "tld": "xn--otu796d",
    "server": "https://rdap.zdnsgtld.com/xn--otu796d/"
  },
  {
    "tld": "xn--ses554g",
    "server": "https://rdap.zdnsgtld.com/xn--ses554g/"
  },
  {
    "tld": "xn--1qqw23a",
    "server": "https://restwhois.ngtld.cn/"
  },
  {
    "tld": "xn--55qx5d",
    "server": "https://restwhois.ngtld.cn/"
  },
  {
    "tld": "xn--io0a7i",
    "server": "https://restwhois.ngtld.cn/"
  },
  {
    "tld": "xn--xhq521b",
    "server": "https://restwhois.ngtld.cn/"
  },
  {
    "tld": "airtel",
    "server": "https://tld-rdap.verisign.com/airtel/v1/"
  },
  {
    "tld": "bharti",
    "server": "https://tld-rdap.verisign.com/bharti/v1/"
  },
  {
    "tld": "cc",
    "server": "https://tld-rdap.verisign.com/cc/v1/"
  },
  {
    "tld": "comsec",
    "server": "https://tld-rdap.verisign.com/comsec/v1/"
  },
  {
    "tld": "name",
    "server": "https://tld-rdap.verisign.com/name/v1/"
  },
  {
    "tld": "nissay",
    "server": "https://tld-rdap.verisign.com/nissay/v1/"
  },
  {
    "tld": "verisign",
    "server": "https://tld-rdap.verisign.com/verisign/v1/"
  },
  {
    "tld": "xn--11b4c3d",
    "server": "https://tld-rdap.verisign.com/xn--11b4c3d/v1/"
  },
  {
    "tld": "xn--3pxu8k",
    "server": "https://tld-rdap.verisign.com/xn--3pxu8k/v1/"
  },
  {
    "tld": "xn--42c2d9a",
    "server": "https://tld-rdap.verisign.com/xn--42c2d9a/v1/"
  },
  {
    "tld": "xn--5su34j936bgsg",
    "server": "https://tld-rdap.verisign.com/xn--5su34j936bgsg/v1/"
  },
  {
    "tld": "xn--9dbq2a",
    "server": "https://tld-rdap.verisign.com/xn--9dbq2a/v1/"
  },
  {
    "tld": "xn--c2br7g",
    "server": "https://tld-rdap.verisign.com/xn--c2br7g/v1/"
  },
  {
    "tld": "xn--fhbei",
    "server": "https://tld-rdap.verisign.com/xn--fhbei/v1/"
  },
  {
    "tld": "xn--j1aef",
    "server": "https://tld-rdap.verisign.com/xn--j1aef/v1/"
  },
  {
    "tld": "xn--mk1bu44c",
    "server": "https://tld-rdap.verisign.com/xn--mk1bu44c/v1/"
  },
  {
    "tld": "xn--pssy2u",
    "server": "https://tld-rdap.verisign.com/xn--pssy2u/v1/"
  },
  {
    "tld": "xn--t60b56a",
    "server": "https://tld-rdap.verisign.com/xn--t60b56a/v1/"
  },
  {
    "tld": "xn--tckwe",
    "server": "https://tld-rdap.verisign.com/xn--tckwe/v1/"
  },
  {
    "tld": "xn--w4r85el8fhu5dnra",
    "server": "https://tld-rdap.verisign.com/xn--w4r85el8fhu5dnra/v1/"
  },
  {
    "tld": "xn--w4rs40l",
    "server": "https://tld-rdap.verisign.com/xn--w4rs40l/v1/"
  },
  {
    "tld": "ky",
    "server": "https://whois.kyregistry.ky/rdap/"
  },
  {
    "tld": "mtr",
    "server": "https://whois.nic.mtr/rdap/"
  },
  {
    "tld": "tatar",
    "server": "https://whois.nic.tatar/rdap/"
  },
  {
    "tld": "xn--d1acj3b",
    "server": "https://whois.nic.xn--d1acj3b/rdap/"
  },
  {
    "tld": "sr",
    "server": "https://whois.sr/rdap/"
  },
  {
    "tld": "tz",
    "server": "https://whois.tznic.or.tz/rdap/"
  },
  {
    "tld": "click",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "country",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "gift",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "hiv",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "juegos",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "link",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "property",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "sexy",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "trust",
    "server": "https://whois.uniregistry.net/rdap/"
  },
  {
    "tld": "fj",
    "server": "https://www.rdap.fj/"
  }
];